/*
 * @Author: your name
 * @Date: 2021-09-22 14:25:36
 * @LastEditTime: 2022-02-17 15:54:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ruigu-launchpad-new/src/components/IndexContent/IndexContent.js
 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import placeholderImg from "@/assets/images/placeholder.png";
import "./IndexContent.styl";

class IndexContentItem extends Component {
  state = {
    menuList: [1508, 1509, 1553, 1554, 1566, 1567, 1573],
    modalInfo: {
      visible: false,
      menu: [],
    },
  };

  cancelModalInfo = () => {
    this.setState({
      modalInfo: {
        visible: false,
        title: "",
        menu: [],
      },
    });
  };

  render() {
    const { item = {} } = this.props;
    const isProduction = process.env.REACT_APP_ENV === "production"; // 生产环境

    return (
      <div className={`system-module-list module-list-${item.id}`}>
        {item.children
          .filter((item) => item.path || item.children.length > 0)
          .map((moduleItem) => {
            const imgUrl =
              typeof moduleItem.icon === "string"
                ? moduleItem.icon.includes("http") ||
                  moduleItem.icon.includes("https")
                  ? moduleItem.icon
                  : placeholderImg
                : placeholderImg;
            return (
              <div
                className={
                  isProduction
                    ? `system-module-item production pointer`
                    : "system-module-item pointer"
                }
                key={moduleItem.id}
                onClick={() => this.props.onItmeClick(moduleItem)}
              >
                <img
                  src={imgUrl}
                  alt="placeholder"
                  className="display-block system-module-img"
                />
                <span className="display-block system-module-name fs-14 text-center text-ellipsis">
                  {moduleItem.title}
                </span>
                <span className="display-block system-module-description text-center fs-12 text-line-2-ellipsis">
                  {moduleItem.menuDescription || "模块暂无介绍"}
                </span>
              </div>
            );
          })}
      </div>
    );
  }
}

export default withRouter(IndexContentItem);
